import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { LoadingPanelService } from 'src/app/shared/loading-panel/loading-panel.service';
import { ToastService, ToastType } from 'src/app/shared/toast/toast.service';
import { AttachmentMetadata, SentMail, SmtpSettings } from '../models/sent-mail';
import { SentMailService } from '../services/sent-mail.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';

import { BizJsonViewerComponent } from '../../shared/json-viewer/json-viewer.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'ep-mail-log',
  templateUrl: './mail-log.component.html',
  styleUrls: ['./mail-log.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, DxDataGridModule, BizDataGridDirective, DxiColumnModule, DxTemplateModule, BizJsonViewerComponent]
})
export class MailLogComponent implements OnInit {

  log: SentMail[] = [];

  constructor(
    private sentMailService: SentMailService,
    private loadingPanelService: LoadingPanelService,
    private toastService: ToastService,
    public dateTimeService: DateTimeService) {
  }

  ngOnInit(): void {
    void this.refresh();
  }

  async refresh(): Promise<void> {
    try {
      this.log = [];
      this.loadingPanelService.showLoadingPanelDirect('Loading...');

      const now = new Date();
      const from = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      from.setMonth(from.getMonth() - 1); // Automatically wraps around new year
      this.log = await firstValueFrom(this.sentMailService.get(from).pipe(
        map(result => result.map(item => ({ ...item, SmtpSettings: this.getSmtpSettings(item), Attachments: this.getAttachments(item) }) as SentMail))
      ));
    }
    catch (err) {
      console.error(err);
      this.toastService.showToast('Failed to load data...', ToastType.error);
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  hasAttachments(sentMail: SentMail): boolean {
    return !!sentMail?.Attachments?.length;
  }

  getSmtpSettings(sentMail: SentMail): SmtpSettings {
    let smtpSettings: SmtpSettings = null;

    if (sentMail.SmtpSettings) {
      const parsed = JSON.parse(sentMail.SmtpSettings as string) as unknown;
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        smtpSettings = parsed as SmtpSettings;
      }
    }

    return smtpSettings;
  }

  getAttachments(sentMail: SentMail): AttachmentMetadata[] {
    let attachments: AttachmentMetadata[] = [];

    if (sentMail.Attachments) {
      const parsed = JSON.parse(sentMail.Attachments as string) as unknown;
      if (Array.isArray(parsed)) {
        attachments = parsed as AttachmentMetadata[];
      }
    }

    return attachments;
  }
}
